import React from 'react';
import { useAuthStore } from '../../store';
import SuperAdminDashboard from './SuperAdminDashboard';
import AdminDashboard from './AdminDashboard';

const Dashboard = () => {
    const admin = useAuthStore((state) => state.admin);

    if (!admin) return null;

    return (
        <div className="dashboard-container">
            {admin.role === 'superadmin' ? (
                <SuperAdminDashboard />
            ) : (
                <AdminDashboard />
            )}
        </div>
    );
};

export default Dashboard;